import pluralize from "pluralize"
import { Maybe } from "../graphql/generated-types"
import { publicEnvVars } from "./config"
import { TransFnType } from "../components/common/Trans"

export const composeFullName = (firstName?: string, surname?: string) => {
    if (firstName && surname) {
        return firstName + " " + surname
    } else if (!surname) {
        return firstName
    } else if (!firstName) {
        return surname
    } else {
        return ""
    }
}

export const isBrowser = typeof window !== "undefined"

export const isHexColorValid = (hex: Maybe<string>) => hex && /^#[0-9A-F]{6}$/i.test(hex)

export const getLatLngDistanceMiles = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const p = 0.017453292519943295 // Math.PI / 180
    const c = Math.cos
    const a = 0.5 - c((lat2 - lat1) * p) / 2 + (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2

    return (12742 * Math.asin(Math.sqrt(a))) / 1.609344
}

export const metresToMiles = (metres: number) => metres * 0.000621371192

// https://github.com/nefe/You-Dont-Need-jQuery#2.3
export const getOffset = (el: HTMLElement): { top: number; left: number } => {
    if (el && document && document.documentElement) {
        const box = el.getBoundingClientRect()

        return {
            top: box.top + window.pageYOffset - document.documentElement.clientTop,
            left: box.left + window.pageXOffset - document.documentElement.clientLeft,
        }
    } else {
        return {
            top: 0,
            left: 0,
        }
    }
}

export const isUuidV4 = (uuid: string): boolean => {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid)
}

// todo: generate slugs on api
export const slugifyString = (str: string): string => {
    const a = "àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;ěščřžý"
    const b = "aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------escrzy"
    const p = new RegExp(a.split("").join("|"), "g")
    const emojiRegex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/gu

    return str
        .toString()
        .toLowerCase()
        .replace(emojiRegex, (match) => `${match.codePointAt(0).toString(16)}`)
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\p{L}\p{Nd}\-]+/gu, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "") // Trim - from end of text
}

export const simpleDigitToWord = (digit: number, trans: TransFnType): string => {
    switch (digit) {
        case 0:
            return trans("zero")
        case 1:
            return trans("one")
        case 2:
            return trans("two")
        case 3:
            return trans("three")
        case 4:
            return trans("four")
        case 5:
            return trans("five")
        case 6:
            return trans("six")
        case 7:
            return trans("seven")
        case 8:
            return trans("eight")
        case 9:
            return trans("nine")
        case 10:
            return trans("ten")
        default:
            return "" + digit
    }
}

export const plural = (word: string, count: number) => {
    pluralize.addIrregularRule("person", "persons")
    return pluralize(word, count)
}

export const composeAccountAssetPath = (path: string): string => {
    if (path.includes("http")) {
        return path
    } else {
        return `${publicEnvVars.ACCOUNT_ASSETS_URL}${path}`
    }
}

export const generateArrayOfNumbers = (min: number, max: number): number[] => {
    return [...Array(max + 1)].map((_, i) => i).slice(min)
}
